export default function (value) {
  let formattedValue
  if (Number.isInteger(value)) {
    formattedValue = value
  } else {
    formattedValue = parseFloat(value).toLocaleString('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
  return ('€ ' + formattedValue)
}
